export default {
  namespaced: true,
  state: {
    all: [],
    message: '',
    color: '',
    isVisible: false,
    actionText: '',
    actionFunction: null,
  },
  getters: {
    hasSnackbars: (state) => {
      // No snackbars pending or no snackbar currently showing
      return state.all.length !== 0 || state.isVisible === true
    }
  },
  mutations: {
    disableSnackbar (state) {
      state.isVisible = false
      state.message = ''
    },

    setNextSnackbar (state) {
      let snackbar = state.all.shift()
      if (snackbar) {
        state.message = snackbar.message
        state.color = snackbar.color
        state.isVisible = true
        state.actionText = snackbar.actionText
        state.actionFunction = snackbar.actionFunction
      }
    },

    addSnackbar (state, [message, category, actionText, actionFunction]) {
      // Avoid duplicate snackbars
      if (state.message === message || state.all.some(snackbar => snackbar.message === message)) {
        return
      }

      let color = null
      if (category === 'error') {
        color = 'red'
      } else if (category === 'success') {
        color = 'green'
      } else {
        color = 'orange'
      }

      state.all.push({ message, color, actionText, actionFunction })
    }
  },
  actions: {
    showSnackbar ({ getters, commit }, [message, category = 'warning', actionText='', actionFunction=null]) {
      const hasSnackbars = getters.hasSnackbars
      commit('addSnackbar', [message, category, actionText, actionFunction])

      if (!hasSnackbars) {
        commit('setNextSnackbar')
      }
    },

    showNextSnackbar ({ commit }) {
      commit('disableSnackbar')

      // Let the previous snackbar disappear before showing the next
      setTimeout(() => {
        commit('setNextSnackbar')
      }, 500)
    }
  }
}
